import React from 'react';
import LinkifyIt from 'linkify-it';
import { Link } from 'react-router-dom';
import config from '../../../config';

const Linkify = (props) => {
    const linkify = new LinkifyIt();
    linkify.tlds(require('tlds'));

    const isUtrDomain = (url) => {
        const utrDomains = [`app.${config.siteBaseUrl}`, 'localhost:3443', `leagues.${config.siteBaseUrl}`];
        let isUtrLink = false;
        utrDomains.forEach((domain) => {
            if (url.includes(domain)) {
                isUtrLink = true;
            }
        });
        return isUtrLink;
    };

    const parseString = (string) => {
        if (string === '') {
            return string;
        }

        const matches = linkify.match(string);
        if (!matches) {
            return string;
        }

        const elements = [];
        let finalIndex = 0;
        matches.forEach((match, i) => {
            // Push preceding text if there is any
            if (match.index > finalIndex) {
                elements.push(string.substring(finalIndex, match.index));
            }

            if (isUtrDomain(match.url)) {
                // eslint-disable-next-line no-useless-escape
                const pathRegex = /(http[s]?:\/\/)?([^\/\s]+)(.*)/;
                const path = match.url.match(pathRegex)[3];
                elements.push(<Link to={path}>{match.text}</Link>);
            } else {
                elements.push(
                    // eslint-disable-next-line react/no-array-index-key
                    <a href={match.url} key={`link${i}`}>
                        {match.text}
                    </a>
                );
            }

            finalIndex = match.lastIndex;
        });

        // Push remaining text if there is any
        if (string.length > finalIndex) {
            elements.push(string.substring(finalIndex));
        }

        return elements.length === 1 ? elements[0] : elements;
    };

    const parse = (children, key) => {
        if (typeof children === 'string') {
            return parseString(children);
        }

        if (React.isValidElement(children) && children.type !== 'a' && children.type !== 'button') {
            return React.cloneElement(children, { key }, parse(children.props.children));
        }

        if (Array.isArray(children)) {
            return children.map((child, i) => parse(child, i));
        }

        return children;
    };

    return <>{parse(props.children)}</>;
};

export default Linkify;
